module.exports = __webpack_public_path__ + "assets/lessons/en/lesson6/modals/lesson_6_5_a.pdf";